import { useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { useLazyGetFavoredBankContactsQuery, useLazyGetFavoredContactsQuery, } from '../../services/pixFavoredContactApi';
export function useGetFavoredContacts() {
    const { t } = useTranslation();
    const [trigger] = useLazyGetFavoredContactsQuery();
    const [triggerBank] = useLazyGetFavoredBankContactsQuery();
    const [loading, setLoading] = useState(false);
    const [errorGetFavoredContactsMessage, setErrorGetFavoredContactsMessage] = useState();
    const [errorGetFavoredBankContactsMessage, setErrorGetFavoredBankContactsMessage] = useState();
    const [favoredContacts, setFavoredContacts] = useState();
    const [favoredBankContacts, setFavoredBankContacts] = useState();
    async function getFavoredBankContacts() {
        setLoading(true);
        setErrorGetFavoredBankContactsMessage(undefined);
        try {
            const { data, error } = await triggerBank(undefined, false);
            if (error) {
                setErrorGetFavoredContactsMessage(t('select-contact-get-favorites-error-message'));
                return;
            }
            if (data?.result) {
                setFavoredBankContacts(data.result);
            }
        }
        catch {
            setErrorGetFavoredBankContactsMessage(t('select-contact-get-favorites-error-message'));
        }
        finally {
            setLoading(false);
        }
    }
    async function getFavoredContacts() {
        setLoading(true);
        setErrorGetFavoredBankContactsMessage(undefined);
        try {
            const { data, error } = await trigger(undefined, false);
            if (error) {
                setErrorGetFavoredContactsMessage(t('select-contact-get-favorites-error-message'));
                return;
            }
            if (data?.result) {
                setFavoredContacts(data.result);
            }
        }
        catch {
            setErrorGetFavoredBankContactsMessage(t('select-contact-get-favorites-error-message'));
        }
        finally {
            setLoading(false);
        }
    }
    return {
        loading,
        errorGetFavoredContactsMessage,
        setErrorGetFavoredContactsMessage,
        errorGetFavoredBankContactsMessage,
        setErrorGetFavoredBankContactsMessage,
        setLoading,
        favoredContacts,
        setFavoredContacts,
        favoredBankContacts,
        setFavoredBankContacts,
        getFavoredContacts,
        getFavoredBankContacts,
    };
}
